import { Component } from '@angular/core';

@Component({
  selector: 'app-default-layout',
  template: ` <app-nav>
    <router-outlet></router-outlet>
  </app-nav>`,
  styles: [],
})
export class DefaultLayoutComponent {}
